/** @jsxImportSource @emotion/react */
import type { Theme } from "@emotion/react";
import { Global, ThemeProvider } from "@emotion/react";
import type { ReactNode } from "react";
import { Provider as ReakitProvider } from "reakit";
import { theme30 } from "../theme30";

type ProviderProps = {
  children: ReactNode;
  theme?: Theme;
};

function Provider({ children, theme = theme30 }: ProviderProps) {
  return (
    <ReakitProvider>
      <ThemeProvider theme={theme}>
        <Global
          styles={{
            body: {
              background: theme?.colors.body,
            },
          }}
        />
        <div
          css={{
            color: theme?.colors["gray-90"],
            fontSize: theme?.fontSizes["textBase"],
            lineHeight: theme?.lineHeights["textBaseLineHeight"],
          }}
        >
          {children}
        </div>
      </ThemeProvider>
    </ReakitProvider>
  );
}

export { Provider };
